import { it } from 'date-fns/locale';
const dateItIT = {
  name: 'it-IT',
  locale: it
};
export default dateItIT;